import ReactGA from 'react-ga';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY, {
  debug: false,
  titleCase: false,
  anonymizeIp: true,
  testMode: process.env.NODE_ENV === 'test',
  gaOptions: {
    cookieFlags: 'SameSite=None;Secure'
  }
});

const trackEvent = action => {
  ReactGA.event({category: 'Redux Action', action}); // Track event to google analytics
};

const trackPage = pathname => {
  ReactGA.pageview(pathname);
};

/* eslint no-unused-vars: "off"*/
const middleware = store => next => action => {
  const {type} = action;
  ReactGA.set({anonymizeIp: true});

  if (type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`;
    trackPage(nextPage);
  }
  else if (!type.includes('persist/')) {
    trackEvent(type);
  }

  return next(action);
};

export default middleware;
